import React from 'react';
import './courseHabits.css'
import C2wCourseHabitCard from '../../../../common/C2wHome/courseDetails/C2wCourseHabitCard';

function C2wCourseHabits( { courseData } ) {
    return (
        <div className='C2wCourseHabits_ctn'>
            <div className='C2wCourseHabits_content_card'>
                <div className='C2wCourseHabits_content_div'>
                    <div className='C2wCoureseDetailComponentHeading_ctn'>
                        <div className='heading'>
                            {`${'Develop programming habits by'} `}
                        </div>
                    </div>
                    <div className='C2wCourseHabits_content_SubCards_hld'>
                        { courseData && courseData?.map((obj, index) => (
                            <C2wCourseHabitCard obj={obj} />
                        ))}
                    </div>
                </div>
                <img src='/assets/images/courseDetails/girlImg.png' alt='' />
            </div>

        </div>
    )
}

export default C2wCourseHabits
